<template>
  <grid id="endDeviceLastEventsGrid"
        :title="$t('ed-lastEvents:lastEvents')"
        :columns="columns"
        :paginated-dto="rows"
        :pagination="false"
        :download-btn="false"
        :refresh-btn="false"
        compact
        @load="getEvents"
  >
    <template slot="date" slot-scope="props">{{ props.dto.date | date }}</template>

    <div slot="actions" slot-scope="props" class="actions">
      <i :title="$t('ed-lastEvents:markAsRead') | capitalize" class="icon-check" @click="markAsRead(props.dto)" />
    </div>
  </grid>
</template>

<script>
import { isEmpty } from 'lodash-es'
import to from '@/modules/await-to-js'

export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      rows: {}
    }
  },

  computed: {
    columns () {
      return [
        { text: this.$t('ed-lastEvents:date'), slot: 'date' },
        { text: this.$t('ed-lastEvents:name'), formatter: event => event.name },
        { text: this.$t('ed-lastEvents:value'), formatter: event => event.value },
        { slot: 'actions' }
      ]
    }
  },

  watch: {
    endDevice () {
      this.getEvents()
    }
  },

  created () {
    this.getEvents()
  },

  methods: {
    async getEvents () {
      if (isEmpty(this.endDevice)) return

      const params = { page: 1, pageSize: 5, sort: '-date', search: JSON.stringify({ operation: 'eq', operand: 'read', values: ['false'] }) }
      let error, response
      [error, response] = await to(this.$api.getEndDeviceLastEvents(this.endDevice, params))
      if (error || !response) return

      this.rows = response.data
    },

    async markAsRead (event) {
      let error
      [error] = await to(this.$api.patchLastEvent(event, { read: true }))
      if (error) return

      this.$store.dispatch('getLastLnsEventsCounters', { loader: false, defaultErrorMessage: false })
      this.getEvents()
    }
  }
}
</script>
